import { trackAdsBannerTeaserEvent } from './analytics';
import { normalizePage } from './utils';
import { TAnalyticsMessagePayload } from '../../types';

export function teaserHandler([, eventParams]: TAnalyticsMessagePayload, pageRaw: unknown) {
  const { sc, product, page: eventPage } = eventParams;

  const page = normalizePage(pageRaw);

  if (eventPage?.extra) {
    page.extra = {
      ...page.extra,
      ...eventPage.extra,
    };
  }

  switch (true) {
    case product.name === 'Listing_show_TGB' || product.name === 'Listing_click_TGB': {
      trackAdsBannerTeaserEvent({ sc, product, page });
      break;
    }
  }
}
